
	import { defineComponent } from 'vue'

	import { useDynamicPhoneNumber } from '@/composables/useDynamicPhoneNumber'

	export default defineComponent({
		props: {
			phoneNumber: {
				'type': String,
				'required': false,
				'default': (): string => '1-877-790-1540',
			},
		},

		setup(props) {
			return useDynamicPhoneNumber(props.phoneNumber)
		},
	})
